import React from 'react';
import { FormattedMessage } from 'react-intl';

const OwnerDetails = (props) => {
  if (!props.owner) {
    return null;
  }
  return [
    <dt key="ownerTitle">
      <FormattedMessage id="components.contactDetails.owner" defaultMessage="Owner" />
    </dt>,
    <dd key="ownerData">{props.owner.name}</dd>
  ];
};

export default OwnerDetails;
